import React, { useState } from 'react';
import Section from './Section';
import { servicesData } from '../data/services';
import evaIntegral from '../assets/evaInte.png';
import planPersonalizado from '../assets/plan.png';
import acompanamientoFamiliar from '../assets/acoFam.png';

// Ilustraciones SVG únicas por servicio (sin dependencias externas)
const ServiceIllustration = ({ serviceId, cat }) => {
  const bgs = {
    evaluacion: ['#f3f0ff', '#ddd6fe'],
    tratamiento: ['#fff0f3', '#fecdd3'],
    asesoria:    ['#fffbeb', '#fde68a'],
    estimulacion:['#f0f9ff', '#bae6fd'],
    educativo:   ['#f0fdf4', '#a7f3d0'],
  };
  const [c1, c2] = bgs[cat] || bgs.evaluacion;
  const gid = `svgg${serviceId}`;

  const Dots = () => (
    <>
      <circle cx="18" cy="18" r="13" fill="white" opacity="0.35"/>
      <circle cx="282" cy="158" r="18" fill="white" opacity="0.28"/>
      <circle cx="272" cy="22" r="9" fill="white" opacity="0.3"/>
      <circle cx="28" cy="158" r="11" fill="white" opacity="0.28"/>
    </>
  );

  const scenes = {
    /* 1 · ADOS-2: rompecabezas + figura niño */
    1: <><Dots/>
      <rect x="72" y="28" width="68" height="68" rx="14" fill="#a78bfa" opacity="0.55"/>
      <rect x="158" y="28" width="68" height="68" rx="14" fill="#c4b5fd" opacity="0.55"/>
      <rect x="72" y="106" width="68" height="68" rx="14" fill="#c4b5fd" opacity="0.55"/>
      <rect x="158" y="106" width="68" height="68" rx="14" fill="#a78bfa" opacity="0.55"/>
      <circle cx="150" cy="88" r="24" fill="#fd567a" opacity="0.85"/>
      <circle cx="150" cy="80" r="11" fill="white" opacity="0.75"/>
      <path d="M138 97 Q150 108 162 97" stroke="white" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <circle cx="48" cy="62" r="5" fill="#fd567a" opacity="0.6"/>
      <circle cx="255" cy="72" r="4" fill="#8b5cf6" opacity="0.6"/>
    </>,

    /* 2 · ADI-R: dos globos de diálogo */
    2: <><Dots/>
      <rect x="38" y="38" width="112" height="72" rx="18" fill="#a78bfa" opacity="0.6"/>
      <polygon points="68,110 52,138 94,110" fill="#a78bfa" opacity="0.6"/>
      <rect x="152" y="66" width="112" height="72" rx="18" fill="#c4b5fd" opacity="0.6"/>
      <polygon points="218,138 244,163 232,138" fill="#c4b5fd" opacity="0.6"/>
      <circle cx="78" cy="74" r="7" fill="white" opacity="0.65"/>
      <circle cx="98" cy="74" r="7" fill="white" opacity="0.65"/>
      <circle cx="118" cy="74" r="7" fill="white" opacity="0.65"/>
      <circle cx="192" cy="102" r="7" fill="white" opacity="0.65"/>
      <circle cx="212" cy="102" r="7" fill="white" opacity="0.65"/>
      <circle cx="232" cy="102" r="7" fill="white" opacity="0.65"/>
    </>,

    /* 3 · Eval TO: torre de bloques de colores */
    3: <><Dots/>
      <rect x="95" y="112" width="110" height="50" rx="10" fill="#818cf8" opacity="0.65"/>
      <rect x="110" y="72" width="80" height="48" rx="10" fill="#a78bfa" opacity="0.65"/>
      <rect x="123" y="36" width="54" height="44" rx="10" fill="#c4b5fd" opacity="0.65"/>
      <rect x="26" y="92" width="44" height="44" rx="9" fill="#fd567a" opacity="0.5"/>
      <rect x="232" y="96" width="44" height="44" rx="9" fill="#ffc7df" opacity="0.6"/>
      <rect x="228" y="48" width="38" height="38" rx="8" fill="#818cf8" opacity="0.45"/>
      <circle cx="48" cy="155" r="8" fill="#fd567a" opacity="0.35"/>
    </>,

    /* 4 · Eval Fono: boca + ondas de sonido */
    4: <><Dots/>
      <ellipse cx="150" cy="82" rx="48" ry="32" fill="#fd567a" opacity="0.72"/>
      <ellipse cx="150" cy="94" rx="36" ry="16" fill="white" opacity="0.55"/>
      <path d="M212 62 Q234 82 212 102" stroke="#a78bfa" strokeWidth="4" fill="none" strokeLinecap="round"/>
      <path d="M228 48 Q260 82 228 116" stroke="#a78bfa" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M244 36 Q284 82 244 128" stroke="#c4b5fd" strokeWidth="3" fill="none" strokeLinecap="round"/>
      <path d="M88 62 Q66 82 88 102" stroke="#a78bfa" strokeWidth="4" fill="none" strokeLinecap="round"/>
      <path d="M72 48 Q40 82 72 116" stroke="#c4b5fd" strokeWidth="3" fill="none" strokeLinecap="round"/>
      <ellipse cx="150" cy="148" rx="20" ry="16" fill="#ffc7df" opacity="0.65"/>
    </>,

    /* 5 · Sesión Tratamiento: calendario + corazón */
    5: <><Dots/>
      <rect x="58" y="30" width="118" height="118" rx="14" fill="#fb7185" opacity="0.5"/>
      <rect x="58" y="30" width="118" height="32" rx="14" fill="#f43f5e" opacity="0.5"/>
      {[82,102,122,142].map(x=>[78,96,114].map(y=>(
        <circle key={`${x}-${y}`} cx={x} cy={y} r="5" fill="white" opacity="0.55"/>
      )))}
      <path d="M210 58 C210 47 221 42 232 48 C243 42 254 47 254 58 C254 70 232 92 232 92 C232 92 210 70 210 58Z" fill="#fd567a" opacity="0.88"/>
      <rect x="192" y="112" width="72" height="30" rx="15" fill="#ffc7df" opacity="0.75"/>
      <circle cx="213" cy="127" r="7" fill="#fd567a" opacity="0.8"/>
    </>,

    /* 6 · Habilidades Sociales: tres figuras + arco */
    6: <><Dots/>
      <circle cx="78" cy="60" r="26" fill="#fda4af" opacity="0.7"/>
      <circle cx="78" cy="52" r="13" fill="white" opacity="0.65"/>
      <rect x="63" y="86" width="30" height="46" rx="10" fill="#fda4af" opacity="0.6"/>
      <circle cx="150" cy="48" r="30" fill="#fd567a" opacity="0.72"/>
      <circle cx="150" cy="39" r="15" fill="white" opacity="0.65"/>
      <rect x="133" y="78" width="34" height="52" rx="12" fill="#fd567a" opacity="0.6"/>
      <circle cx="222" cy="60" r="26" fill="#fda4af" opacity="0.7"/>
      <circle cx="222" cy="52" r="13" fill="white" opacity="0.65"/>
      <rect x="207" y="86" width="30" height="46" rx="10" fill="#fda4af" opacity="0.6"/>
      <path d="M88 142 Q150 162 212 142" stroke="#fd567a" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.5"/>
      <circle cx="112" cy="40" r="6" fill="#fd567a" opacity="0.55"/>
      <circle cx="188" cy="40" r="6" fill="#fd567a" opacity="0.55"/>
    </>,

    /* 7 · Lectoescritura: libro abierto + lápiz */
    7: <><Dots/>
      <path d="M150 38 L56 60 L56 152 L150 128Z" fill="#fb923c" opacity="0.52"/>
      <path d="M150 38 L244 60 L244 152 L150 128Z" fill="#fbbf24" opacity="0.52"/>
      <rect x="145" y="38" width="10" height="90" rx="5" fill="#92400e" opacity="0.28"/>
      <line x1="72" y1="84" x2="138" y2="77" stroke="white" strokeWidth="2.5" opacity="0.6"/>
      <line x1="72" y1="100" x2="138" y2="94" stroke="white" strokeWidth="2.5" opacity="0.6"/>
      <line x1="72" y1="116" x2="138" y2="110" stroke="white" strokeWidth="2.5" opacity="0.6"/>
      <line x1="162" y1="84" x2="228" y2="77" stroke="white" strokeWidth="2.5" opacity="0.6"/>
      <line x1="162" y1="100" x2="228" y2="94" stroke="white" strokeWidth="2.5" opacity="0.6"/>
      <text x="80" y="76" fontSize="26" fill="white" opacity="0.75" fontWeight="bold" fontFamily="sans-serif">A</text>
      <text x="168" y="76" fontSize="26" fill="white" opacity="0.75" fontWeight="bold" fontFamily="sans-serif">B</text>
      <rect x="222" y="110" width="14" height="52" rx="4" fill="#fbbf24" transform="rotate(-28,229,136)"/>
      <polygon points="218,148 230,148 224,168" fill="#f97316" transform="rotate(-28,224,158)"/>
    </>,

    /* 8 · Asesorías padres: laptop + familia */
    8: <><Dots/>
      <rect x="48" y="38" width="136" height="90" rx="10" fill="#f59e0b" opacity="0.52"/>
      <rect x="58" y="47" width="116" height="72" rx="6" fill="white" opacity="0.45"/>
      <rect x="38" y="128" width="156" height="10" rx="5" fill="#f59e0b" opacity="0.42"/>
      <circle cx="96" cy="80" r="13" fill="#fd567a" opacity="0.68"/>
      <circle cx="122" cy="80" r="13" fill="#fbbf24" opacity="0.68"/>
      <circle cx="109" cy="100" r="10" fill="#ffc7df" opacity="0.68"/>
      <circle cx="232" cy="62" r="26" fill="#fbbf24" opacity="0.62"/>
      <circle cx="232" cy="54" r="13" fill="white" opacity="0.62"/>
      <rect x="217" y="88" width="30" height="40" rx="10" fill="#fbbf24" opacity="0.5"/>
      <path d="M218 135 C218 129 223 126 228 129 C233 126 238 129 238 135 C238 141 228 149 228 149 C228 149 218 141 218 135Z" fill="#fd567a" opacity="0.8"/>
    </>,

    /* 9 · Lactancia: madre + bebé + corazones */
    9: <><Dots/>
      <ellipse cx="150" cy="95" rx="72" ry="76" fill="#fbbf24" opacity="0.32"/>
      <circle cx="150" cy="40" r="34" fill="#fbbf24" opacity="0.58"/>
      <circle cx="150" cy="32" r="17" fill="white" opacity="0.62"/>
      <path d="M92 88 Q72 118 88 146" stroke="#fbbf24" strokeWidth="20" fill="none" strokeLinecap="round" opacity="0.62"/>
      <path d="M208 88 Q228 118 212 146" stroke="#fbbf24" strokeWidth="20" fill="none" strokeLinecap="round" opacity="0.62"/>
      <ellipse cx="150" cy="128" rx="38" ry="30" fill="#ffc7df" opacity="0.75"/>
      <circle cx="150" cy="110" r="18" fill="#ffc7df" opacity="0.8"/>
      <path d="M72 54 C72 50 76 48 79 50 C82 48 86 50 86 54 C86 58 79 64 79 64 C79 64 72 58 72 54Z" fill="#fd567a" opacity="0.7"/>
      <path d="M210 50 C210 46 214 44 217 46 C220 44 224 46 224 50 C224 54 217 60 217 60 C217 60 210 54 210 50Z" fill="#fd567a" opacity="0.7"/>
      <circle cx="150" cy="158" r="7" fill="#fbbf24" opacity="0.4"/>
    </>,

    /* 10 · Lavado oídos: oreja + gotas de agua */
    10: <><Dots/>
      <path d="M132 28 C90 28 62 58 62 90 C62 132 84 157 110 157 C121 157 130 150 134 142 C142 127 136 110 142 94 C148 78 164 72 168 57 C173 38 158 22 132 28Z" fill="#38bdf8" opacity="0.62"/>
      <path d="M126 54 C105 54 94 70 94 88 C94 112 108 130 122 130" stroke="#0ea5e9" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.65"/>
      <ellipse cx="202" cy="62" rx="14" ry="22" fill="#7dd3fc" opacity="0.7"/>
      <path d="M202 40 Q206 34 202 40" stroke="#7dd3fc" strokeWidth="2" fill="none"/>
      <ellipse cx="232" cy="98" rx="11" ry="17" fill="#bae6fd" opacity="0.7"/>
      <ellipse cx="214" cy="136" rx="9" ry="14" fill="#7dd3fc" opacity="0.6"/>
      <path d="M244 56 L249 46 L254 56 L264 61 L254 66 L249 76 L244 66 L234 61Z" fill="#38bdf8" opacity="0.5"/>
      <circle cx="185" cy="42" r="6" fill="#0ea5e9" opacity="0.45"/>
    </>,

    /* 11 · Estimulación Temprana: bebé + juguetes + estrellas */
    11: <><Dots/>
      <ellipse cx="150" cy="148" rx="104" ry="18" fill="#7dd3fc" opacity="0.38"/>
      <ellipse cx="148" cy="118" rx="54" ry="32" fill="#ffc7df" opacity="0.68"/>
      <circle cx="184" cy="100" r="24" fill="#ffc7df" opacity="0.75"/>
      <circle cx="184" cy="93" r="13" fill="white" opacity="0.62"/>
      <path d="M128 122 Q108 112 98 122" stroke="#ffc7df" strokeWidth="13" fill="none" strokeLinecap="round" opacity="0.7"/>
      <circle cx="76" cy="106" r="20" fill="#fd567a" opacity="0.58"/>
      <rect x="66" y="96" width="20" height="20" rx="5" fill="white" opacity="0.3"/>
      <circle cx="62" cy="142" r="14" fill="#38bdf8" opacity="0.52"/>
      <path d="M212 48 L217 36 L222 48 L234 53 L222 58 L217 70 L212 58 L200 53Z" fill="#fbbf24" opacity="0.7"/>
      <path d="M242 84 L246 74 L250 84 L260 88 L250 92 L246 102 L242 92 L232 88Z" fill="#38bdf8" opacity="0.58"/>
      <circle cx="54" cy="72" r="8" fill="#fbbf24" opacity="0.58"/>
    </>,

    /* 12 · Estimulación en Agua: olas + bebé + sol */
    12: <><Dots/>
      <rect x="0" y="102" width="300" height="74" fill="#38bdf8" opacity="0.38"/>
      <path d="M0 106 Q38 90 75 106 Q112 122 150 106 Q188 90 225 106 Q262 122 300 106" stroke="#0ea5e9" strokeWidth="4" fill="none" opacity="0.58"/>
      <path d="M0 126 Q38 110 75 126 Q112 142 150 126 Q188 110 225 126 Q262 142 300 126" stroke="#7dd3fc" strokeWidth="3" fill="none" opacity="0.48"/>
      <ellipse cx="148" cy="92" rx="42" ry="24" fill="#ffc7df" opacity="0.72"/>
      <circle cx="180" cy="76" r="22" fill="#ffc7df" opacity="0.78"/>
      <circle cx="180" cy="69" r="11" fill="white" opacity="0.62"/>
      <path d="M128 90 Q108 78 98 88" stroke="#ffc7df" strokeWidth="11" fill="none" strokeLinecap="round" opacity="0.7"/>
      <circle cx="58" cy="38" r="26" fill="#fbbf24" opacity="0.58"/>
      {[0,45,90,135,180,225,270,315].map(a=>(
        <line key={a} x1={58+29*Math.cos(a*Math.PI/180)} y1={38+29*Math.sin(a*Math.PI/180)} x2={58+40*Math.cos(a*Math.PI/180)} y2={38+40*Math.sin(a*Math.PI/180)} stroke="#fbbf24" strokeWidth="3" opacity="0.58"/>
      ))}
      <circle cx="204" cy="76" r="8" fill="white" opacity="0.48"/>
      <circle cx="224" cy="62" r="6" fill="white" opacity="0.4"/>
    </>,

    /* 13 · Charlas: pizarrón + terapeuta + audiencia */
    13: <><Dots/>
      <rect x="82" y="22" width="148" height="98" rx="10" fill="#34d399" opacity="0.52"/>
      <rect x="92" y="31" width="128" height="80" rx="6" fill="white" opacity="0.42"/>
      <line x1="156" y1="120" x2="156" y2="146" stroke="#6ee7b7" strokeWidth="4" strokeLinecap="round"/>
      <line x1="138" y1="146" x2="174" y2="146" stroke="#6ee7b7" strokeWidth="4" strokeLinecap="round"/>
      <circle cx="44" cy="58" r="19" fill="#10b981" opacity="0.68"/>
      <circle cx="44" cy="50" r="10" fill="white" opacity="0.62"/>
      <rect x="33" y="77" width="22" height="36" rx="9" fill="#10b981" opacity="0.58"/>
      <path d="M58 87 Q76 74 94 66" stroke="#10b981" strokeWidth="8" fill="none" strokeLinecap="round" opacity="0.58"/>
      {[198,224,250].map((x,i)=>(
        <g key={i}>
          <circle cx={x} cy={132} r={12} fill="#34d399" opacity={0.6}/>
          <circle cx={x} cy={124} r={7} fill="white" opacity="0.58"/>
        </g>
      ))}
      <rect x="100" y="46" width="14" height="42" fill="#10b981" opacity="0.48"/>
      <rect x="120" y="58" width="14" height="30" fill="#6ee7b7" opacity="0.48"/>
      <rect x="140" y="50" width="14" height="38" fill="#10b981" opacity="0.48"/>
      <rect x="160" y="66" width="14" height="22" fill="#6ee7b7" opacity="0.48"/>
    </>,

    /* 14 · Visitas domiciliarias: casa + corazón */
    14: <><Dots/>
      <polygon points="150,18 262,88 38,88" fill="#34d399" opacity="0.62"/>
      <rect x="54" y="88" width="192" height="88" rx="0" fill="#6ee7b7" opacity="0.58"/>
      <rect x="118" y="128" width="44" height="48" rx="8" fill="#10b981" opacity="0.62"/>
      <circle cx="154" cy="154" r="4" fill="white" opacity="0.8"/>
      <rect x="64" y="106" width="38" height="32" rx="5" fill="white" opacity="0.48"/>
      <rect x="198" y="106" width="38" height="32" rx="5" fill="white" opacity="0.48"/>
      <line x1="83" y1="106" x2="83" y2="138" stroke="#6ee7b7" strokeWidth="2"/>
      <line x1="64" y1="122" x2="102" y2="122" stroke="#6ee7b7" strokeWidth="2"/>
      <line x1="217" y1="106" x2="217" y2="138" stroke="#6ee7b7" strokeWidth="2"/>
      <line x1="198" y1="122" x2="236" y2="122" stroke="#6ee7b7" strokeWidth="2"/>
      <path d="M132 148 C132 143 136 141 138 143 C140 141 144 143 144 148 C144 153 138 159 138 159 C138 159 132 153 132 148Z" fill="white" opacity="0.82"/>
      <circle cx="46" cy="46" r="19" fill="#fbbf24" opacity="0.52"/>
      <circle cx="248" cy="78" r="24" fill="#34d399" opacity="0.42"/>
      <rect x="242" y="100" width="12" height="26" fill="#10b981" opacity="0.4"/>
    </>,

    /* 15 · Visitas escolar: colegio + birrete */
    15: <><Dots/>
      <rect x="46" y="68" width="186" height="108" rx="6" fill="#34d399" opacity="0.58"/>
      <polygon points="139,16 244,68 34,68" fill="#10b981" opacity="0.68"/>
      <line x1="139" y1="4" x2="139" y2="18" stroke="#059669" strokeWidth="3"/>
      <polygon points="139,4 166,13 139,22" fill="#fd567a" opacity="0.7"/>
      {[70,112,158,202].map((x,i)=>(
        <rect key={i} x={x} y={88} width={26} height={26} rx="4" fill="white" opacity="0.48"/>
      ))}
      <rect x="112" y="136" width="54" height="40" rx="8" fill="#059669" opacity="0.68"/>
      <circle cx="157" cy="158" r="4" fill="white" opacity="0.8"/>
      <rect x="50" y="148" width="56" height="40" rx="6" fill="#fbbf24" opacity="0.68"/>
      <line x1="78" y1="148" x2="78" y2="188" stroke="#92400e" strokeWidth="2.5" opacity="0.5"/>
      <rect x="218" y="126" width="52" height="12" rx="3" fill="#6ee7b7" opacity="0.7"/>
      <polygon points="244,96 270,126 218,126" fill="#34d399" opacity="0.72"/>
      <line x1="267" y1="128" x2="274" y2="148" stroke="#10b981" strokeWidth="2.5"/>
      <circle cx="274" cy="152" r="5" fill="#10b981" opacity="0.72"/>
    </>,
  };

  return (
    <svg viewBox="0 0 300 176" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={c1}/>
          <stop offset="100%" stopColor={c2}/>
        </linearGradient>
      </defs>
      <rect width="300" height="176" fill={`url(#${gid})`}/>
      {scenes[serviceId] || scenes[1]}
    </svg>
  );
};

// Category config: color variants and SVG icons per service id
const categoryConfig = {
  evaluacion: {
    label: 'Evaluación',
    cardBg: 'bg-gradient-to-br from-violet-50 to-purple-50',
    badgeBg: 'bg-violet-100 text-violet-700',
    iconBg: 'bg-violet-100',
    iconColor: 'text-violet-600',
    borderHover: 'hover:border-violet-300',
  },
  tratamiento: {
    label: 'Tratamiento',
    cardBg: 'bg-gradient-to-br from-rose-50 to-pink-50',
    badgeBg: 'bg-rose-100 text-rose-700',
    iconBg: 'bg-rose-100',
    iconColor: 'text-rose-500',
    borderHover: 'hover:border-rose-200',
  },
  asesoria: {
    label: 'Asesoría',
    cardBg: 'bg-gradient-to-br from-amber-50 to-orange-50',
    badgeBg: 'bg-amber-100 text-amber-700',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    borderHover: 'hover:border-amber-300',
  },
  estimulacion: {
    label: 'Estimulación',
    cardBg: 'bg-gradient-to-br from-sky-50 to-blue-50',
    badgeBg: 'bg-sky-100 text-sky-700',
    iconBg: 'bg-sky-100',
    iconColor: 'text-sky-600',
    borderHover: 'hover:border-sky-300',
  },
  educativo: {
    label: 'Educativo',
    cardBg: 'bg-gradient-to-br from-emerald-50 to-teal-50',
    badgeBg: 'bg-emerald-100 text-emerald-700',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
    borderHover: 'hover:border-emerald-300',
  },
};

const serviceCategories = {
  1: 'evaluacion',
  2: 'evaluacion',
  3: 'evaluacion',
  4: 'evaluacion',
  5: 'tratamiento',
  6: 'tratamiento',
  7: 'tratamiento',
  8: 'asesoria',
  9: 'asesoria',
  10: 'estimulacion',
  11: 'estimulacion',
  12: 'estimulacion',
  13: 'educativo',
  14: 'educativo',
  15: 'educativo',
};

const ServiceIcons = {
  evaluacion: ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
    </svg>
  ),
  tratamiento: ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
    </svg>
  ),
  asesoria: ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  estimulacion: ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
  educativo: ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
    </svg>
  ),
};

const categoryTabs = ['todos', 'evaluacion', 'tratamiento', 'asesoria', 'estimulacion', 'educativo'];
const tabLabels = {
  todos: 'Todos',
  evaluacion: 'Evaluaciones',
  tratamiento: 'Tratamiento',
  asesoria: 'Asesorías',
  estimulacion: 'Estimulación',
  educativo: 'Educativo',
};

const CheckIcon = () => (
  <svg className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
);

const Services = () => {
  const [activeFilter, setActiveFilter] = useState('todos');

  const filtered = activeFilter === 'todos'
    ? servicesData
    : servicesData.filter((s) => serviceCategories[s.id] === activeFilter);

  return (
    <Section id="servicios" className="bg-white">

      {/* Header */}
      <div className="text-center mb-12">
        <span className="badge bg-primary/10 text-primary mb-4">Lo que ofrecemos</span>
        <h2 className="section-title mb-4">Nuestros Servicios</h2>
        <p className="section-subtitle">
          Ofrecemos una amplia gama de terapias especializadas para el desarrollo integral de tu hijo
        </p>
      </div>

      {/* Filter tabs */}
      <div className="flex flex-wrap justify-center gap-2 mb-10">
        {categoryTabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveFilter(tab)}
            className={`px-4 py-2 rounded-2xl text-sm font-semibold transition-all duration-200 cursor-pointer ${
              activeFilter === tab
                ? 'bg-primary text-white shadow-md'
                : 'bg-gray-100 text-text/60 hover:bg-secondary/40 hover:text-text'
            }`}
          >
            {tabLabels[tab]}
          </button>
        ))}
      </div>

      {/* Service cards grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((service) => {
          const cat = serviceCategories[service.id] || 'evaluacion';
          const config = categoryConfig[cat];
          const Icon = ServiceIcons[cat];

          return (
            <div
              key={service.id}
              className={`group ${config.cardBg} rounded-3xl border-2 border-transparent ${config.borderHover} hover:shadow-xl transition-all duration-300 flex flex-col overflow-hidden`}
            >
              {/* Cover illustration */}
              <div className="relative h-44 overflow-hidden transition-transform duration-500 group-hover:scale-105">
                <ServiceIllustration serviceId={service.id} cat={cat} />
                {/* Category badge over illustration */}
                <span className={`absolute top-3 right-3 badge ${config.badgeBg} text-xs shadow-sm`}>
                  {config.label}
                </span>
              </div>

              <div className="p-6 flex flex-col flex-1">
              {/* Card header icon + title */}
              <div className="flex items-start gap-3 mb-3">
                <div className={`w-10 h-10 ${config.iconBg} rounded-2xl flex items-center justify-center flex-shrink-0`}>
                  <Icon className={`w-5 h-5 ${config.iconColor}`} />
                </div>
                <h3 className="font-fredoka text-xl text-text leading-snug">{service.title}</h3>
              </div>

              {/* Description */}
              {service.description && (
                <p className="text-sm text-text/65 leading-relaxed mb-4 line-clamp-3 font-nunito">
                  {service.description.replace(/--$/, '').trim()}
                </p>
              )}

              {/* Features */}
              <div className="mt-auto space-y-1.5">
                <p className="text-xs font-semibold text-text/50 uppercase tracking-wide mb-2">
                  {service.includes}
                </p>
                {service.features.map((feat, i) => (
                  <div key={i} className="flex items-start gap-2">
                    <CheckIcon />
                    <span className="text-xs text-text/70 font-nunito leading-relaxed">{feat}</span>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <button
                onClick={() => window.open('https://walink.co/eea878', '_blank')}
                className="mt-5 w-full py-2.5 rounded-2xl text-sm font-semibold border-2 border-current text-text/60 hover:bg-white/70 hover:text-text transition-all duration-200 cursor-pointer"
              >
                Consultar
              </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Highlights */}
      <div className="mt-20 grid md:grid-cols-3 gap-6">
        {[
          { img: evaIntegral, title: 'Evaluación Integral', desc: 'Evaluaciones completas para identificar las necesidades específicas de cada niño' },
          { img: planPersonalizado, title: 'Plan Personalizado', desc: 'Planes de tratamiento únicos adaptados a las necesidades individuales de cada niño' },
          { img: acompanamientoFamiliar, title: 'Acompañamiento Familiar', desc: 'Incluimos a toda la familia en el proceso terapéutico para mejores resultados' },
        ].map((item) => (
          <div key={item.title} className="bg-gradient-to-br from-secondary/20 to-background/30 rounded-3xl p-8 text-center space-y-4">
            <img src={item.img} alt={item.title} className="mx-auto w-16 h-16 object-contain" />
            <h3 className="font-fredoka text-xl text-text">{item.title}</h3>
            <p className="text-sm text-text/65 font-nunito leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* CTA Banner */}
      <div className="mt-16 bg-gradient-to-r from-primary/10 via-secondary/20 to-background/30 rounded-3xl p-10 text-center">
        <h3 className="font-fredoka text-3xl text-text mb-3">
          ¿No estás seguro qué servicio necesitas?
        </h3>
        <p className="text-text/65 mb-6 max-w-lg mx-auto font-nunito">
          Nos puedes escribir y te ayudaremos a identificar la mejor opción para tu hijo.
        </p>
        <button
          onClick={() => window.open('https://walink.co/eea878', '_blank')}
          className="btn-primary"
        >
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.549 4.12 1.516 5.855L0 24l6.335-1.496A11.934 11.934 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.865 0-3.63-.482-5.17-1.33l-.37-.215-3.762.888.933-3.658-.24-.38A9.944 9.944 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
          </svg>
          Hablemos por WhatsApp
        </button>
      </div>
    </Section>
  );
};

export default Services;
